export default __webpack_public_path__ + "static/media/banner-bikiran.f038ca8a.svg";